import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { ICONS } from '@shared/constants/icons.constant';
import { GlobalSearchHotkeyService } from '@shared/global-search';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class App {
  // -----------------------------------------------------------------------------------------------------
  // @ CONSTRUCTOR
  // -----------------------------------------------------------------------------------------------------

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    // Define custom icons to use with mat-icon
    for (const [icon, svg] of Object.entries(ICONS)) {
      this.matIconRegistry.addSvgIconLiteral(icon, this.domSanitizer.bypassSecurityTrustHtml(svg));
    }
  }

  // No default scope: the palette opens clean — scope chips only appear when a page
  // hands over real context (the earlier "Objekt: Test" was leftover demo wiring)
  private readonly globalSearch = inject(GlobalSearchHotkeyService).initialize();
}
